<template>
	<div class="profile-wrapper">
		<div class="title">惊喜好物 
			<span class="jifen">
				<el-image :src="require('@/assets/golds.png')" fit="fill"></el-image>
				<span>积分余额：</span>
				<span class="jifenNum">{{totalNum}}</span>
			</span>
		</div>
		<div class="goods-wrapper">
			<div class="goods-item" v-for="item in dataList">
				<div class="good-msg">
					<el-image class="cover" :src="item.cover" fit="fill"></el-image>
					<div class="name">{{item.productName}}</div>
					<div class="jifen">
						<el-image :src="require('@/assets/jifen.png')" fit="fill"></el-image>
						<span class="price">{{item.points}}</span>
						<span class="original" v-if="item.original">{{item.original}}</span>
						<span class="exchangeNum">库存：{{item.stock}}</span>
					</div>
				</div>
				<div class="btn">
					<el-button type="warning" size="small" class="submit" @click="exchange(item)">立即兑换</el-button>
				</div>
			</div>
		</div>
		<el-pagination
			:hide-on-single-page="true"
		    layout="prev, pager, next"
		    :total="total">
		  </el-pagination>
	</div>
</template>

<script>
import { getGoodList } from '@/api/personal/fuli'
export default {
  data () {
    return {
		dataList:[],
		totalNum: 0,
		total: 0
    }
  },
  methods: {
	async getList(){
	  	const res = await getGoodList()
	  	if (res.code === 0) {
	  		this.dataList = res.data.list
			this.total = res.data.total
	  	} else {
	  	  this.$message.error(res.msg)
	  	}
	},
    exchange(item){
		this.$router.push({name: 'exchange-detail',params:{data:item}})
	}
  },
  mounted () {
	this.getList()
	this.totalNum = JSON.parse(localStorage.getItem('user')).integral
  }

}
</script>

<style lang="scss" scoped>
.profile-wrapper{
	padding: 30px 40px;
	.title{
		font-size: 20px;
		font-weight: 800;
		border-bottom: 1px solid #D4D4E6;
		padding-bottom: 10px;
		.jifen{
			color: #505050;
			font-size: 14px;
			font-weight: 500;
			float: right;
			.el-image{
				width: 35px;
				height: 25px;
				vertical-align: bottom;
			}
			.jifenNum{
				color: #313131;
				font-size: 20px;
				font-weight: 800;
			}
		}
	}
	.goods-wrapper{
		margin: 20px 0;
		display: flex;
		flex-wrap: wrap;
		.goods-item{
			flex: 0 0 24%;
			box-sizing: border-box;
			margin: 0 1% 1% 0;
			border: 1px solid #DDDDDD;
			.good-msg{
				border-bottom: 1px solid #DDDDDD;
				padding-bottom: 10px;
				.cover{
					width: 100%;
					height: 120px;
				}
				.name{
					padding: 5px 15px;
					font-size: 18px;
					font-weight: 800;
					color: #383838;
				}
				.jifen{
					padding: 0 15px;
					.el-image{
						width: 18px;
						height: 18px;
						vertical-align: sub;
					}
					.price{
						color: #FF842E;
						margin: 0 3px;
					}
					.original{
						text-decoration: line-through;
						color: #8B8B8B;
						font-size: 12px;
					}
					.exchangeNum{
						color: #8B8B8B;
						font-size: 12px;
						float: right;
						margin-top: 4px;
					}
				}
			}
			.btn{
				text-align: center;
				.submit{
					background-color: #FF842E;
					border-radius: 20px;
					width: 100px;
					margin: 10px 0;
				}
			}
		}
	}
	/deep/.el-pager li.active {
	    color: #FF842E;
	    cursor: default;
	}
	/deep/.el-pager li:hover {
	    color: #FF842E;
	}
	/deep/.el-pagination button:hover{
		color: #FF842E;
	}
	/deep/.el-image__error{
		height: 100px;
	}
	/deep/.el-pagination{
		text-align: center;
		margin: 30px 0 20px;
	}
	/deep/.el-pagination .btn-next,
	/deep/.el-pagination .btn-prev,
	/deep/.el-pager li{
		background: unset;
	}
}	

</style>